module.exports = __webpack_public_path__ + "img/zhAward-a.b946c451.png";